import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAssistantTypeApi } from "../api";
import { defaultMaintenanceConfig } from "../utils/maintenance";

const Maintenance = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(
    defaultMaintenanceConfig.maintenance_page_message,
  );

  useEffect(() => {
    const load = async () => {
      const settings = await getAssistantTypeApi();
      if (!settings?.maintenance_config) {
        return;
      }

      const config = settings.maintenance_config;

      if (!settings.show_maintenance_page) {
        navigate("/", { replace: true });
        return;
      }

      setMessage(
        config.maintenance_page_message ||
          defaultMaintenanceConfig.maintenance_page_message,
      );
    };

    load();
  }, [navigate]);

  return <div style={{ padding: "2rem", textAlign: "center" }}>{message}</div>;
};

export default Maintenance;
